import React from 'react';
import './Page.less';

/**
 * Page — the canonical inner container for every dashboard route.
 * Provides horizontal padding, safe-area, and the shared content max-width.
 */
function Page({ children, className = '' }) {
  return <div className={`gc-page ${className}`.trim()}>{children}</div>;
}

export default Page;
